import { useState, useContext } from 'react';
import {
  FiTag,
  FiList,
  FiBriefcase,
  FiMapPin,
  FiGlobe,
  FiCalendar,
  FiCheckCircle,
  FiImage
} from 'react-icons/fi';
import { LiaRupeeSignSolid } from "react-icons/lia";
import { DataProvider } from '../../../store/ContextProvider';
import CreatableSelect from 'react-select/creatable';
import industriesData from '../../../data/industryTypes.json'
import { TbInfoTriangleFilled } from "react-icons/tb";
import { IoPeopleOutline } from "react-icons/io5";
import { compressImage } from '../../../utils/compressImage';

import ReactQuill from "react-quill-new";
import "react-quill-new/dist/quill.snow.css";

const allFonts = [
  "sans-serif",
  "serif",
  "monospace",
  "arial",
  "times-new-roman",
  "courier-new",
  "georgia",
  "comic-sans-ms",
  "tahoma",
  "verdana",
  "calibri",
  "cambria",
  "garamond",
  "lucida-console",
  "palatino",
  "trebuchet-ms",
  "impact",
];


const formats = [
  "font",
  "header",
  "bold",
  "italic",
  "underline",
  "strike",
  "blockquote",
  "color",
  "background",
  "code-block",
  "list",
  "bullet",
  "script",
  "align",
  "link",
  "image",
  "video",
];

const Font = ReactQuill.Quill.import("formats/font");
Font.whitelist = allFonts;
ReactQuill.Quill.register(Font, true);

export default function CreateJob() {

  const modules = {
    toolbar: [
      [{ font: Font.whitelist }],
      [{ header: [1, 2, 3, 4, 5, 6, false] }],
      ["bold", "italic", "underline", "strike"],
      [{ color: [] }, { background: [] }],
      [{ align: [] }],
      ["blockquote", "code-block"],
      [{ list: "ordered" }, { list: "bullet" }],
      [{ script: "sub" }, { script: "super" }],
      ["link", "image", "video"],
      ["clean"],
    ],
  };

  const { BeURL, showAlert } = useContext(DataProvider);
  const industryOptions = industriesData.industryTypes;
  const LOCATION_TYPES = ['onsite', 'remote', 'hybrid'];
  const EMPLOY_TYPES = ['ft', 'pt', 'contract'];

  const [form, setForm] = useState({
    title: '',
    description: '',
    client: '',
    skills: [],
    // requirements: [],
    expMin: '',
    expMax: '',
    salMin: '',
    salMax: '',
    locationType: '',
    city: '',
    industry: '',
    employmentType: '',
    openings: 1,
    deadline: '',
    isEnable: true
  });
  const [tempTag, setTempTag] = useState({ field: '', value: '' });
  const [errors, setErrors] = useState({});
  const [clientLogo, setClientLogo] = useState(null);
  const [logoPreview, setLogoPreview] = useState(null);
  const [isCompressing, setIsCompressing] = useState(false);

  const handleChange = (k) => (e) => {
    const val = e.target.type === 'checkbox'
      ? e.target.checked
      : e.target.value;


    setForm(f => ({ ...f, [k]: val }));
  };


  const handleJdchange = value => {
    setForm({ ...form, description: value })
  }

  const handleBlur = (k) => () => {
    const e = {};
    const v = form[k];
    switch (k) {
      case 'title':
        if (!v.trim()) e.title = 'Required';
        break;
      case 'client':
        if (!v.trim()) e.client = 'Required'
        break
      case 'description':
        if (!v.trim()) e.description = 'Required';
        break;
      case 'expMin':
      case 'expMax':
        if (!/^\d+(\.\d+)?$/.test(v)) e[k] = 'Number required';
        break;
      case 'salMin':
      case 'salMax':
        if (!/^(?:[1-9]\d{0,1})(?:\.\d{1})?$/.test(v.trim())) {
          e[k] = 'Number required';
        } else if (isNaN(v.trim())) {
          e[k] = 'Only numbers allowed';
        } else {
          e[k] = ""
        }
        break;
      case 'locationType':
        if (!LOCATION_TYPES.includes(v)) e.locationType = 'Select one';
        break;
      case 'city':
        if (form.locationType === 'onsite' || form.locationType === 'hybrid') {
          if (!v.trim()) {
            e.city = 'Required for onsite';
          } else if (!/^[A-Za-z\s,]+$/.test(v.trim())) {
            e.city = 'Only alphabets and spaces are allowed';
          }
          else {
            e.city = ""
          }
        }
        break;
      case 'industry':
        if (!v.trim()) {
          e.industry = 'Required';
        } else if (!/^[A-Za-z\s]+$/.test(v.trim())) {
          e.industry = 'Only alphabets and spaces are allowed';
        }
        else {
          e.industry = ""
        }
        break;
      case 'employmentType':
        if (!EMPLOY_TYPES.includes(v)) e.employmentType = 'Select one';
        break;
      case 'openings':
        if (!v) e.openings = 'This field is required'
        break
      case 'deadline':
        if (!v) e.deadline = 'Required';
        // else if (new Date(v) < new Date()) e.deadline = 'Must be future';
        break;
      default:
        break;
    }
    setErrors(err => ({ ...err, ...e }));
  };



  const addTag = (field) => {
    if (!tempTag.value.trim()) return;
    setForm(f => ({
      ...f,
      [field]: [...f[field], tempTag.value.trim()]
    }));
    setTempTag({ field: '', value: '' });
    setErrors(err => ({ ...err, [field]: '' }));
  };

  const removeTag = (field, idx) => {
    setForm(f => ({
      ...f,
      [field]: f[field].filter((_, i) => i !== idx)
    }));
  };

  const validateAll = () => {
    const e = {};
    if (!form.title.trim()) e.title = 'Required';
    if (!form.client.trim()) e.client = 'Required';
    if (!form.description.trim()) e.description = 'Required';
    if (form.skills.length === 0) e.skills = 'Add ≥1';
    // if (form.requirements.length===0) e.requirements = 'Add ≥1';
    if (!/^\d+(\.\d+)?$/.test(form.expMin)) e.expMin = 'Number';
    if (!/^\d+(\.\d+)?$/.test(form.expMax)) e.expMax = 'Number';
    if (form.expMax * 1 < form.expMin * 1)
      e.expMax = '≥ min exp';
    if (!/^\d+(\.\d+)?$/.test(form.salMin)) e.salMin = 'Number';
    if (!/^\d+(\.\d+)?$/.test(form.salMax)) e.salMax = 'Number';
    if (form.salMax * 1 < form.salMin * 1)
      e.salMax = '≥ min sal';
    if (!LOCATION_TYPES.includes(form.locationType))
      e.locationType = 'Select';
    if ((form.locationType === 'onsite' || form.locationType === 'hybrid') && !form.city.trim())
      e.city = 'Required';
    if (!form.industry.trim()) e.industry = 'Required';
    if (!EMPLOY_TYPES.includes(form.employmentType))
      e.employmentType = 'Select';
    if (!form.openings) e.openings = 'Required'
    if (!form.deadline) e.deadline = 'Required';
    // else if (new Date(form.deadline) < new Date())
    //   e.deadline = 'Future only';
    setErrors(e);
    return Object.keys(e).length === 0;
  };

  const handleSubmit = async () => {
    if (!validateAll()) return;
    const payload = {
      title: form.title.trim(),
      client: form.client.trim(),
      description: form.description.trim(),
      skills: form.skills,
      // requirements: form.requirements,
      experience: { min: +form.expMin, max: +form.expMax },
      salary: { min: +form.salMin, max: +form.salMax },
      location: { type: form.locationType, city: form.city.trim() },
      industry: form.industry.trim(),
      employmentType: form.employmentType,
      openings: form.openings,
      deadline: form.deadline,
      isEnable: form.isEnable,
      clientLogo: clientLogo || null
    };
    try {
      const res = await fetch(`${BeURL}/create-job`, {
        method: 'POST',
        credentials: 'include',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify(payload)
      });
      const data = await res.json();
      showAlert(data.message);
      if (data.success) {
        window.location.href = "/list-jobs"
      }
    } catch {
      showAlert('Trouble in connecting to the Server! please try again later.');
    }
  };

  const handleLogoUpload = async (e) => {
    const file = e.target.files[0];
    if (!file) return;

    // Validate file type
    const validTypes = ['image/png', 'image/jpg', 'image/jpeg', 'image/gif', 'image/webp'];
    if (!validTypes.includes(file.type)) {
      showAlert('Please select a valid image file (PNG, JPG, JPEG, GIF, or WEBP)');
      return;
    }

    try {
      setIsCompressing(true);
      setErrors(prev => ({ ...prev, clientLogo: '' }));

      // Compress the image
      const compressedFile = await compressImage(file, { maxSizeMB: 4.5, maxWidthOrHeight: 1920 });

      // Check compressed size (should be under 5MB)
      const sizeInMB = compressedFile.size / (1024 * 1024);
      if (sizeInMB > 5) {
        setErrors(prev => ({ ...prev, clientLogo: 'Image size exceeds 5MB even after compression. Please use a smaller image.' }));
        setIsCompressing(false);
        return;
      }

      // Convert to base64
      const reader = new FileReader();
      reader.onloadend = () => {
        const base64String = reader.result;
        setClientLogo(base64String);
        setLogoPreview(base64String);
        setIsCompressing(false);
      };
      reader.readAsDataURL(compressedFile);
    } catch (error) {
      console.error('Error compressing image:', error);
      showAlert('Failed to compress image. Please try again.');
      setIsCompressing(false);
    }
  };

  const removeClientLogo = () => {
    setClientLogo(null);
    setLogoPreview(null);
    setErrors(prev => ({ ...prev, clientLogo: '' }));
  };

  const manBadge = () => {
    return <span className='text-red-600 text-lg font-medium'> *</span>
  }

  return (
    <div className="bg-white my-2 p-6 rounded-xl shadow space-y-6">
      <h2 className="text-2xl font-semibold text-primary-400">Create Job</h2>

      <div className='flex flex-wrap sm:flex-nowrap gap-4'>
        {/* Title */}
        <div className="flex flex-col w-full">
          <label className="font-medium">Job Title{manBadge()}</label>
          <input
            type="text" value={form.title}
            onChange={handleChange('title')}
            onBlur={handleBlur('title')}
            className="border rounded p-2 mt-1"
            placeholder='Eg: Reactjs Developer'
          />
          {errors.title && !form.title && <p className="text-red-600 text-sm">{errors.title}</p>}
        </div>

        {/* Client */}
        <div className="flex flex-col w-full">
          <label className="font-medium">Client Category/ Name{manBadge()}</label>
          <input
            type="text" value={form.client}
            onChange={handleChange('client')}
            onBlur={handleBlur('client')}
            className="border rounded p-2 mt-1"
            placeholder='eg: Top MNC (or) Top Leading MNC'
          />
          {errors.client && !form.client && <p className="text-red-600 text-sm">{errors.client}</p>}
        </div>
      </div>

      {/* Client Logo */}
      <div className="flex flex-col">
        <label className="flex items-center gap-1 font-medium">
          <FiImage />Client Logo
        </label>
        <div className="mt-2">
          <input
            type="file"
            accept="image/png, image/jpg, image/jpeg, image/gif, image/webp"
            onChange={handleLogoUpload}
            disabled={isCompressing}
            className="border rounded p-2 w-full"
          />
          {isCompressing && (
            <p className="text-blue-600 text-sm mt-1">Compressing image...</p>
          )}
          {errors.clientLogo && (
            <p className="text-red-600 text-sm mt-1">{errors.clientLogo}</p>
          )}
        </div>
        {logoPreview && (
          <div className="mt-3 flex items-start gap-3">
            <img
              src={logoPreview}
              alt="Client logo preview"
              className="w-32 h-32 object-contain border rounded"
            />
            <button
              onClick={removeClientLogo}
              className="px-3 py-1 bg-red-500 text-white rounded hover:bg-red-600"
            >
              Remove
            </button>
          </div>
        )}
      </div>

      {/* Description */}
      {/* <div className="flex flex-col max-h-[50vh] overflow-y-auto">
        <label className="font-medium">Description{manBadge()} <span className='text-slate-700 font-normal text-sm inline-flex items-center'>(<TbInfoTriangleFilled/> &nbsp; Accepts only paragraphs without any formatting)</span></label>
        <textarea
          value={form.description}
          placeholder='Enter Description here'
          onChange={(e) => {
            handleChange('description')(e);  // your existing form update
            e.target.style.height = "auto";  // reset previous height
            e.target.style.height = e.target.scrollHeight + "px"; // grow to fit content
          }}
          onBlur={handleBlur('description')}
          rows={4}
          className="border rounded p-2 mt-1 resize-none"
          style={{ minHeight: "4rem" }} // approx 4 rows default
        />
        {errors.description && !form.description && <p className="text-red-600 text-sm">{errors.description}</p>}
      </div> */}

      {/* Tags */}
      {['skills'].map(field => (
        <div key={field} className="flex flex-col">
          <label className="flex items-center gap-1 font-medium">
            {field === 'skills' ? <FiTag /> : <FiList />}
            {field.charAt(0).toUpperCase() + field.slice(1)}{manBadge()}
            {
              field === 'requirements' &&
              <span className='text-slate-700 font-normal text-sm inline-flex items-center'>(<TbInfoTriangleFilled /> &nbsp; Adding sentences here will be visible as Bullet points)</span>
            }
          </label>
          <div className="flex gap-2 mt-1">
            <input
              type="text"
              value={tempTag.field === field ? tempTag.value : ''}
              onChange={e => setTempTag({ field, value: e.target.value })}
              onKeyDown={e => e.key === 'Enter' && addTag(field)}
              className="flex-1 border rounded p-2"
              placeholder={field === 'requirements' ? 'Eg: "Strong experience in Java and Python" and hit enter' : `Type a skill(eg: ReactJs) and hit Enter`}
            />
            <button
              onClick={() => addTag(field)}
              className="px-3 py-1 bg-primary-500 text-white rounded"
            >+</button>
          </div>
          {errors[field] && <p className="text-red-600 text-sm">{errors[field]}</p>}
          <div className="flex flex-wrap gap-2 mt-2">
            {form[field].map((tag, i) => (
              <span
                key={i}
                className="bg-gray-100 px-2 py-1 rounded flex items-center gap-1"
              >
                {tag}
                <button onClick={() => removeTag(field, i)} className="text-red-500">×</button>
              </span>
            ))}
          </div>
        </div>
      ))}

      {/* Exp & Sal */}
      <div className="flex flex-wrap gap-4">
        {[
          { key: 'expMin', lab: 'Min Exp (in Years)', icon: <FiBriefcase />, holder: "eg: 1" },
          { key: 'expMax', lab: 'Max Exp (in Years)', icon: <FiBriefcase />, holder: "eg: 3" },
          { key: 'salMin', lab: 'Min Salary (in LPA)', icon: <LiaRupeeSignSolid />, holder: "eg: 6" },
          { key: 'salMax', lab: 'Max Salary (in LPA)', icon: <LiaRupeeSignSolid />, holder: "eg: 22" }
        ].map(({ key, lab, icon, holder }) => (
          <div key={key} className="flex-1 flex flex-col">
            <label className="flex items-center gap-1 font-medium">{icon}{lab}{manBadge()}</label>
            <input
              type="tel"
              value={form[key]}
              onChange={handleChange(key)}
              onBlur={handleBlur(key)}
              className="border rounded p-2 mt-1"
              placeholder={holder || ""}
            />
            {errors[key] && <p className="text-red-600 text-sm">{errors[key]}</p>}
          </div>
        ))}
      </div>

      {/* Location & Others */}
      <div className="flex flex-wrap gap-4">
        <div className="flex-1 flex flex-col">
          <label className="font-medium">Work mode{manBadge()}</label>
          <select
            value={form.locationType}
            onChange={handleChange('locationType')}
            onBlur={handleBlur('locationType')}
            className="border rounded p-2 mt-1"
          >
            <option value="" disabled>Select here</option>
            {LOCATION_TYPES.map(l => (
              <option key={l} value={l}>{l}</option>
            ))}
          </select>
          {errors.locationType && <p className="text-red-600 text-sm">{errors.locationType}</p>}
        </div>
        {(form.locationType === 'onsite' || form.locationType === 'hybrid') && (
          <div className="flex-1 flex flex-col">
            <label className="flex items-center gap-1 font-medium"><FiMapPin />City{manBadge()}</label>
            <input
              type="text"
              value={form.city}
              onChange={handleChange('city')}
              onBlur={handleBlur('city')}
              className="border rounded p-2 mt-1"
            />
            {errors.city && <p className="text-red-600 text-sm">{errors.city}</p>}
          </div>
        )}
        {/* <div className="flex-1 flex flex-col">
          <label className="flex items-center gap-1 font-medium"><FiGlobe/>Industry{manBadge()}</label>
          <input
            type="text"
            value={form.industry}
            onChange={handleChange('industry')}
            onBlur={handleBlur('industry')}
            className="border rounded p-2 mt-1"
          />
          {errors.industry&&<p className="text-red-600 text-sm">{errors.industry}</p>}
        </div> */}
        <div className="flex-1 flex flex-col">
          <label className="flex items-center gap-1 font-medium"><FiGlobe />Industry{manBadge()}</label>
          <CreatableSelect
            styles={{
              control: base => ({
                ...base,
                padding: '0.1rem',
                marginTop: '4px'
              })
            }}
            classNamePrefix="react-select"
            options={industryOptions}
            value={
              form.industry
                ? industryOptions.find(opt => opt.value === form.industry) || { label: form.industry, value: form.industry }
                : null
            }
            onChange={(selected) =>
              setForm(f => ({ ...f, industry: selected ? selected.value : "" }))
            }
            onBlur={handleBlur('industry')}
            placeholder="Select or type industry"
            isClearable
          />
        </div>
        <div className="flex-1 flex flex-col">
          <label className="font-medium">Employment Type{manBadge()}</label>
          <select
            value={form.employmentType}
            onChange={handleChange('employmentType')}
            onBlur={handleBlur('employmentType')}
            className="border rounded p-2 mt-1"
          >
            <option value="" disabled>Select here</option>
            {EMPLOY_TYPES.map(t => (
              <option key={t} value={t}>{t.toUpperCase()}</option>
            ))}
          </select>
          {errors.employmentType && <p className="text-red-600 text-sm">{errors.employmentType}</p>}
        </div>
      </div>

      {/* Deadline */}
      <div className="flex flex-wrap gap-4">
        <div className="flex flex-col">
          <label className="flex items-center gap-1 font-medium"><IoPeopleOutline />No. of. Openings{manBadge()}</label>
          <input
            type="number"
            value={form.openings}
            onChange={handleChange('openings')}
            onBlur={handleBlur('openings')}
            min={1}
            className="border rounded p-2 mt-1"
          />
          {errors.openings && <p className="text-red-600 text-sm">{errors.openings}</p>}
        </div>
        <div className="flex flex-col">
          <label className="flex items-center gap-1 font-medium"><FiCalendar />Deadline{manBadge()}</label>
          <input
            type="date"
            value={form.deadline}
            onChange={handleChange('deadline')}
            onBlur={handleBlur('deadline')}
            min={new Date().toISOString().split('T')[0]}
            className="border rounded p-2 mt-1"
          />
          {errors.deadline && <p className="text-red-600 text-sm">{errors.deadline}</p>}
        </div>
      </div>

      {/* Live */}
      <div className="flex items-center gap-2">
        <input
          type="checkbox"
          checked={form.isEnable}
          onChange={handleChange('isEnable')}
        />
        <label className="flex items-center gap-1"><FiCheckCircle />Live Posting?</label>
      </div>

      {/* Description */}
      <div className="flex flex-col">
        <label className="font-medium">Description{manBadge()}</label>
        <ReactQuill
          theme="snow"
          value={form.description}
          name='description'
          onChange={handleJdchange}
          modules={modules}
          formats={formats}
          placeholder="Enter you JD here..."
          className='rounded-lg'
        />
        {errors.description && !form.description && <p className="text-red-600 text-sm">{errors.description}</p>}
      </div>

      {/* Submit */}
      <div className="flex justify-end gap-2">
        <button className='border border-red-600 text-red-600 px-3 py-1 rounded' onClick={() => window.location.href = "/"}>Close</button>
        <button
          onClick={handleSubmit}
          className="bg-primary-500 text-white px-6 py-2 rounded"
        >
          Create Job
        </button>
      </div>
    </div>
  );
}
